// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"525":"d27275d5","653":"00e4501b","807":"7357e8dd","978":"fe1bcd2c"}[chunkId] + ".js";
};